import { mapActions, mapGetters } from 'vuex';

/**
 * Helper mixin that checks if the user is connected with QuickBooks.'
 * This guard is made as a mixin because we need to fetch data before checking.
 * Therefore, this can't be on the router level.
 */
export default {
  computed: {
    ...mapGetters('entities/users', ['isDistributorQuickBooksConnected']),
  },
  methods: {
    ...mapActions('entities/users', ['initDistributorLoggedUser']),
  },
  async created() {
    await this.initDistributorLoggedUser();
    if (!this.isDistributorQuickBooksConnected) {
      this.$router.replace({
        name: 'distributor-quick-books-not-connected',
        params: {
          flash: {
            title: 'You are not connected to QuickBooks.',
            type: 'fail',
          },
        },
      });
    }
  },
};
